import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Breadcrumb, Avatar } from 'antd';
import { makeStyles } from '@material-ui/core';
import ArrowNextIcon from '../../../asset/arrow-next.svg';
import CButton from '../../../component/Button';
import formatDate from '../../../helpers/formatDate';
import Loader from '../../../component/Loader/Loader';
import { fetchAllComments, removeComment } from '../../../actions/CommentsAction';

const useStyles = makeStyles({
  gridContainer: {
    display: 'grid',
    gridRowGap: '25px',
    gridTemplateColumns: '33% 33% 33%',
    marginLeft: '90px',
    marginTop: '55px'
  },
  gridHeader: {
    display: 'grid',
    gridRowGap: '25px',
    gridTemplateColumns: '33% 33% 33%',
    marginLeft: '90px'
  },
  gridItem: {
    maxWidth: '90%',
    textAlign: 'start',
    wordWrap: 'break-word'
  },
  gridItemContainer1: {
    '& div': {
      marginBottom: '20px'
    },
    gridColumn: '1',
    gridRow: 'span 1',
    height: '100%',
    maxWidth: '90%',
    textAlign: 'start'
  },
  gridItemContainer2: {
    '& div': {
      marginBottom: '20px'
    },
    gridColumn: 'span 2',
    gridRow: 'span 1',
    height: '100%',
    maxWidth: '90%',
    textAlign: 'start'
  },
  gridItemHeader1: {
    gridColumn: '1',
    gridRow: 'span 1',
    maxWidth: '90%',
    textAlign: 'start'
  },
  gridItemHeader2: {
    gridColumn: 'span 2',
    gridRow: 'span 1',
    maxWidth: '90%',
    textAlign: 'start'
  },
  imageStyle: {
    borderRadius: '50%',
    display: 'flex',
    height: '55px',
    left: '-68px',
    position: 'absolute',
    width: '55px'
  },
  p: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%',
    marginTop: '5px'
  },
  selectHeader: {
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    margin: '0px'
  },
  span: {
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500
  },
  usersInfo: {
    display: 'flex'
  }
});

const CommentsDetail = () => {
  const { commentId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const comments = useSelector(({ comment }) => comment.comments);
  const currentProject = useSelector(({ project }) => project.currentProject);
  const selectedComment = comments.find((item) => item._id === commentId);

  useEffect(() => {
    async function load() {
      dispatch(fetchAllComments());
    }
    if (currentProject) {
      load();
    }
  }, [currentProject, dispatch]);

  function itemRender(route, params, routes) {
    const last = routes.indexOf(route) === routes.length - 1;

    return last ? (
      <span>{route.breadcrumbName}</span>
    ) : (
      <span onClick={() => history.goBack()} style={{ cursor: 'pointer' }}>
        {route.breadcrumbName}
      </span>
    );
  }

  const routes = [
    {
      breadcrumbName: 'Complains',
      path: '/ecommerce/comments'
    },
    {
      breadcrumbName: commentId || '-',
      path: `/ecommerce/comments/${commentId}`
    }
  ];

  const onItemDelete = () => {
    dispatch(
      removeComment(currentProject._id, commentId, () => {
        dispatch(fetchAllComments());
      })
    );
    history.goBack();
  };

  const ComplainHeader = () => {
    const finalDate = formatDate(selectedComment?.createdAt) || '-';

    return (
      <div className={classes.gridHeader}>
        <div className={classes.gridItemHeader1} style={{ position: 'relative' }}>
          <Avatar
            className={classes.imageStyle}
            src={selectedComment?.item?.imageUrl || '-'}
            style={{ borderRadius: '12px' }}
          />
          <span className={classes.span}>{selectedComment?.item?.title || '-'}</span>
          <p className={classes.p}>
            ID: <span style={{ color: 'black' }}>{selectedComment?.itemId || '-'}</span>
          </p>
        </div>
        <div className={classes.gridItemHeader2}>
          <span className={classes.span}>{finalDate || '-'}</span>
          <p className={classes.p}>Date & Time</p>
        </div>
      </div>
    );
  };

  const ComplainBody = () => {
    const author = `@${selectedComment?.profile?.userName}`;
    // const seller = `@${selectedComment.profile.userName}`
    return (
      <div className={classes.gridContainer}>
        <div className={classes.gridItemContainer1}>
          <div className={classes.gridItem}>
            <p className={classes.p}>Author</p>
            <div className={classes.usersInfo}>
              <div style={{ marginRight: '10px', width: '50px' }}>
                <Avatar
                  src={selectedComment?.profile?.profilePictureUrl}
                  style={{
                    display: 'flex',
                    height: '50px',
                    marginRight: '8px',
                    width: '50px'
                  }}
                />
              </div>
              <div className={classes.gridItem}>
                <span className={classes.span}>{author || '-'}</span>
                <p className={classes.p}>ID: {selectedComment?.profile?.userId || '-'}</p>
              </div>
            </div>
          </div>
          <div className={classes.gridItem}>
            <p className={classes.p}>Seller</p>
            <div className={classes.usersInfo}>
              <div style={{ marginRight: '10px', width: '50px' }}>
                <Avatar
                  style={{
                    display: 'flex',
                    height: '50px',
                    marginRight: '8px',
                    width: '50px'
                  }}
                />
              </div>
              <div className={classes.gridItem}>
                <span className={classes.span}>-</span>
                <p className={classes.p}>ID:-</p>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.gridItemContainer2}>
          <div className={classes.gridItem}>
            <p className={classes.p}>Comment</p>
            {selectedComment?.text || '-'}
          </div>
          <div
            className={classes.gridItem}
            style={selectedComment?.replyComment ? { display: 'block' } : { display: 'none' }}
          >
            <p className={classes.p}>Reply</p>
            {selectedComment?.replyComment?.text || '-'}
          </div>
        </div>
      </div>
    );
  };

  const isLoaded = useSelector(({ comment }) => comment.isLoaded);

  if (!isLoaded) {
    return <Loader />;
  }
  return (
    <Layout style={{ background: 'white' }}>
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '35px 40px 0px 35px'
        }}
      >
        <Breadcrumb
          itemRender={itemRender}
          routes={routes}
          separator={<img alt="separator icon" src={ArrowNextIcon} />}
          style={{
            background: 'white',
            display: 'flex',
            justifyContent: 'flex-start'
          }}
        />
        <CButton onClick={onItemDelete} type="primary">
          Delete
        </CButton>
      </div>
      <div style={{ marginTop: '55px', padding: '0px 40px 0px 35px' }}>
        <ComplainHeader />
        <ComplainBody />
      </div>
    </Layout>
  );
};
export default CommentsDetail;
